import api from "@/services/api";
import { ENDPOINTS_KARMA, ENDPOINTS_REWARDS } from "@/services/endpoints";

export const getKarmaMe = () => api.get(ENDPOINTS_KARMA.me).then((r) => r.data);

export const getKarmaLedger = () => api.get(ENDPOINTS_KARMA.ledger).then((r) => r.data);

export const getKarmaByUser = (id) => api.get(ENDPOINTS_KARMA.byUser(id)).then((r) => r.data);

export const listRewards = () => api.get(ENDPOINTS_REWARDS.list).then((r) => r.data);

export const getReward = (id) => api.get(ENDPOINTS_REWARDS.detail(id)).then((r) => r.data);

export const redeemReward = (id, payload) =>
  api.post(ENDPOINTS_REWARDS.redeem(id), payload).then((r) => r.data);

export const listRedemptions = () => api.get(ENDPOINTS_REWARDS.redemptions).then((r) => r.data);
